<script setup>
import { useI18n } from 'vue-i18n';
import Input from 'dashboard/components-next/input/Input.vue';

defineProps({
  authType: {
    type: String,
    required: true,
    validator: value => ['none', 'bearer', 'basic', 'api_key'].includes(value),
  },
  mode: {
    type: String,
    default: 'create',
    validator: value => ['create', 'edit'].includes(value),
  },
});

const { t } = useI18n();

const authConfig = defineModel('authConfig', {
  type: Object,
  default: () => ({}),
});
</script>

<template>
  <div class="flex flex-col gap-2">
    <Input
      v-if="authType === 'bearer'"
      v-model="authConfig.token"
      type="password"
      autocomplete="new-password"
      :label="t('ASSISTANT.TOOLS.FORM.AUTH_CONFIG.BEARER_TOKEN.LABEL')"
      :placeholder="
        t('ASSISTANT.TOOLS.FORM.AUTH_CONFIG.BEARER_TOKEN.PLACEHOLDER')
      "
    />
    <template v-else-if="authType === 'basic'">
      <Input
        v-model="authConfig.username"
        :label="t('ASSISTANT.TOOLS.FORM.AUTH_CONFIG.USERNAME.LABEL')"
        :placeholder="
          t('ASSISTANT.TOOLS.FORM.AUTH_CONFIG.USERNAME.PLACEHOLDER')
        "
      />
      <Input
        v-model="authConfig.password"
        type="password"
        autocomplete="new-password"
        :label="t('ASSISTANT.TOOLS.FORM.AUTH_CONFIG.PASSWORD.LABEL')"
        :placeholder="
          t('ASSISTANT.TOOLS.FORM.AUTH_CONFIG.PASSWORD.PLACEHOLDER')
        "
      />
    </template>
    <template v-else-if="authType === 'api_key'">
      <Input
        v-model="authConfig.header_name"
        :label="t('ASSISTANT.TOOLS.FORM.AUTH_CONFIG.HEADER_NAME.LABEL')"
        :placeholder="
          t('ASSISTANT.TOOLS.FORM.AUTH_CONFIG.HEADER_NAME.PLACEHOLDER')
        "
      />
      <Input
        v-model="authConfig.value"
        type="password"
        autocomplete="new-password"
        :label="t('ASSISTANT.TOOLS.FORM.AUTH_CONFIG.HEADER_VALUE.LABEL')"
        :placeholder="
          t('ASSISTANT.TOOLS.FORM.AUTH_CONFIG.HEADER_VALUE.PLACEHOLDER')
        "
      />
    </template>
    <p v-if="mode === 'edit'" class="text-xs text-n-slate-11">
      {{ t('ASSISTANT.TOOLS.FORM.AUTH_CONFIG.EDIT_HINT') }}
    </p>
  </div>
</template>
